import React, { useState } from 'react';
import { Button, Popover, PopoverBody, PopoverHeader } from 'reactstrap';
import useSession from '../../hooks/stateHooks/useSession';
import './ProfileStyle.css';

function ProfileComponent() {
    const sessionHK = useSession();
    const [pop, setPop] = useState(false);

    const togglePop = () => {
        let stt = !pop;
        setPop(stt);
    };

    function handleSessionEnd(){
        sessionHK.endSesion();
    }

    const renderBySession = () => {
        if (sessionHK.isLogged())
            return (
                <>
                    <PopoverHeader>
                        Sesión iniciada
                    </PopoverHeader>
                    <PopoverBody className="p-1" >
                        <div className="d-flex d-fill justify-content-center p-1">
                            <a href={'/user/profile'} target="_self" rel="noreferrer" id="TooltipExample" >Perfil</a>
                        </div>
                        <div className="d-flex d-fill justify-content-center p-1">
                            <a href={'/user/login'} target="_self" rel="noreferrer" id="TooltipExample" onClick={ handleSessionEnd }>Salir</a>
                        </div>
                    </PopoverBody>

                </>
            );
        else
            return (
                <>
                    <PopoverHeader>
                        Necesitas iniciar sesión
                    </PopoverHeader>
                    <PopoverBody className="p-1" >
                        <div className="d-flex flex-column">
                            <div className="d-flex d-fill justify-content-center p-1">
                                <a href={"/user/login"} target="_self" rel="noreferrer" id="TooltipExample" >Iniciar sesión</a>
                            </div>
                            <div className="d-flex d-fill justify-content-center p-1">
                                <a href={"/user/register"} target="_self" rel="noreferrer" id="TooltipExample" >Crear cuenta</a>
                            </div>
                        </div>
                    </PopoverBody>

                </>
            );
    };

    return (
        <div className="d-flex justify-content-end align-items-center">
            <Button id="Popover1" className="secondary-button"
                type="button"
            >
                <i className="bi bi-person-circle"></i>
                &nbsp;&nbsp;Mi cuenta
            </Button>
            <Popover
                isOpen={pop}
                target="Popover1"
                placement="bottom"
                trigger="focus"
                toggle={togglePop}
            >
                {renderBySession()}
            </Popover>
        </div>
    );
}

export default ProfileComponent;